import React from 'react';
import IconType from './iconType';

function ReelIcon({ color = '#424242', width = 16, height = 17, ...rest }: IconType) {
  return (
    <svg {...rest} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 17" fill="none">
      <title>Reel Icon</title>
      <path
        d="M7.9987 1.83203C9.22884 1.83203 10.2182 1.83203 11.0254 1.89058L8.73111 5.33205H5.59962L7.93297 1.83203H7.9987Z"
        fill={color}
      />
      <path
        d="M2.30834 2.80834C3.14325 1.97343 4.41332 1.85251 6.72914 1.835L4.39777 5.33205H1.40148C1.49965 4.15598 1.73657 3.38012 2.30834 2.80834Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33203 8.4987C1.33203 7.6742 1.33203 6.95786 1.34966 6.33205H14.6477C14.6654 6.95786 14.6654 7.6742 14.6654 8.4987C14.6654 11.6414 14.6654 13.2127 13.6891 14.1891C12.7127 15.1654 11.1414 15.1654 7.9987 15.1654C4.856 15.1654 3.28465 15.1654 2.30834 14.1891C1.33203 13.2127 1.33203 11.6414 1.33203 8.4987ZM8.67467 8.88884C9.55736 9.45836 9.9987 9.74312 9.9987 10.1654C9.9987 10.5876 9.55736 10.8724 8.67468 11.4419C7.77995 12.0192 7.33257 12.3078 6.99897 12.0959C6.66536 11.884 6.66536 11.3111 6.66536 10.1654C6.66536 9.01963 6.66536 8.44676 6.99897 8.23482C7.33257 8.02288 7.77994 8.31153 8.67467 8.88884Z"
        fill={color}
      />
      <path
        d="M14.5959 5.33205C14.4977 4.15598 14.2608 3.38012 13.6891 2.80834C13.2908 2.41013 12.7936 2.17433 12.1312 2.03472L9.93296 5.33205H14.5959Z"
        fill={color}
      />
    </svg>
  );
}

export default ReelIcon;
